module.exports = __webpack_public_path__ + "media/assets/icons/trophy-bluegray-500-76db4c4dfce900b1ba1223c5cc7b359c.svg";